import React from "react";
import PropTypes from "prop-types";

import { Colours } from "@learningblocks/shared-components";

export default function RangeSlider(props) {
  const getTickLabels = () => {
    const ticks = [];
    for (let i = 0; i <= (props.max - props.min) / props.step; i++) {
      ticks.push(
        <div
          style={{
            width: "20px",
            height: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span
            style={{
              background: Colours.navy3,
              width: "1px",
              height: "100%",
              display: "block",
            }}
          ></span>
          <span style={{ fontSize: "8px" }}>
            {parseInt(props.min, 10) + i * props.step}
          </span>
        </div>
      );
    }
    return ticks;
  };

  return (
    <div style={{ position: "relative", marginBottom: "16px" }}>
      <div
        className="sliderBackground"
        style={{
          width: "100%",
          height: "8px",
          borderRadius: "5px",
          background: Colours.navy5,
          outline: "none",
          margin: 0,
          position: "absolute",
          top: "6px",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "8px",
            borderRadius: "4px",
            width:
              ((props.value - props.min) / (props.max - props.min)) * 100 + "%",
            background: Colours.navy1,
            pointerEvents: "none",
          }}
        ></div>
        {/*<div class="sliderticks" style={{
          pointerEvents: "none",
          top: 0,
          width: "100%",
          left: 0,
          position: "absolute",
          display: "flex",
          justifyContent: "space-between",
          padding: 0,
        }}>{getTicks()}</div>*/}
        <div
          class="sliderlabels"
          style={{
            pointerEvents: "none",
            top: "calc(100% + 4px)",
            width: "100%",
            left: 0,
            position: "absolute",
            display: "flex",
            justifyContent: "space-between",
            padding: 0,
          }}
        >
          {getTickLabels()}
        </div>
      </div>
      <input
        type="range"
        min={props.min}
        step={props.step}
        max={props.max}
        value={props.value}
        onChange={props.onChange}
        className="pcr_slider"
        id={props.id}
        style={{ width: "100%", position: "relative", zIndex: 1 }}
      />
    </div>
  );
}
RangeSlider.PropTypes = {
  min: PropTypes.int,
  max: PropTypes.int,
  step: PropTypes.int,
  value: PropTypes.int,
  onChange: PropTypes.function,
  id: PropTypes.string,
};
